import { render, staticRenderFns } from "./UnlockIncompleteExams.vue?vue&type=template&id=190e99c9&"
import script from "./UnlockIncompleteExams.vue?vue&type=script&lang=js&"
export * from "./UnlockIncompleteExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports